module.exports = __webpack_public_path__ + "static/assets/635e7e97d81b0a5f630e32b00428c647.svg";